import CaseStatusItem, { Props as ParentProps } from "./CaseStatusItem";

type Props = Omit<ParentProps<CaseMessage>, "className">;

export default function CaseMessageItem(props: Props) {
  return <CaseStatusItem className="case-message" {...props} />;
}
